export const ROUTER_APPLICATIONS = {
  routes: ["/", "/applications", "*"],
};

export const MAIN_SLIDER_APPLICATIONS = [];

export const VEHICLE_OPTIONS_APPLICATIONS = [];
export const DINAMIC_TABS_APPLICATIONS = {};
export const MAIN_TABLE_APPLICATIONS = null;
